
export const routes = (prefix) => [
    {
        path: `/${prefix}/clinics`,
        name: `${prefix}.clinics.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.clinics.index`,
                PageDescription: "Clinic Listing/Create",
            }
        }
    },
];
